import { render, staticRenderFns } from "./LfItemCategories.vue?vue&type=template&id=8e4610f4"
import script from "./LfItemCategories.vue?vue&type=script&lang=js"
export * from "./LfItemCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports